import {
  aDeleteAutomation,
  mockDeleteAutomationOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockDeleteAutomationOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(50);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          deleteAutomation: aDeleteAutomation({
            ok: true,
          }),
        },
      });
    }
  ),
];
